import T from 'i18n-react';

export const isBadPermissionStatus = (statusCode) => {
  const status = parseInt(statusCode, 10);
  return status >= 400 && status < 500;
};

export const getCreateCommentErrorMessage = (errorResponse) => {
  let errorMessage = T.translate('global.genericError');
  try {
    const errorDetails = errorResponse.details;
    const isMaxLengthError =
      errorDetails &&
      errorDetails.length &&
      errorDetails[0].code === 'INVALID_REQUEST_PARAMETER' &&
      errorDetails[0].errors.length &&
      errorDetails[0].errors[0] &&
      errorDetails[0].errors[0].code === 'MAX_LENGTH';

    if (isMaxLengthError) {
      const [commentLength, commentLimit] = errorDetails[0].errors[0].params;
      errorMessage = T.translate('errors.commentCreateError', {
        commentLength,
        commentLimit,
      });
    }
  } catch (err) {
    errorMessage = T.translate('global.genericError');
  }
  return errorMessage;
};
